<template>
  <v-dialog
    v-model="dialog"
    max-width="290"
  >
    <v-card class="text-center">
      <v-card-title 
        class="text-h5 justify-center"
      >
        {{ $t('Logout.title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('Logout.text') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          {{ $t('Common.cancel') }}
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click="logout()"
        >
          {{ $t('Logout.confirm-btn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      dialog: this.isVisible,
    }
  },
  watch: {
    isVisible (value) {
      this.dialog = value
    },
    dialog (value) {
      this.$emit('is-visible', value)
    }
  },
  methods: {
    logout: function () {
      this.dialog = false
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>